import { render, staticRenderFns } from "./double-switcher.vue?vue&type=template&id=5ba6d14c"
import script from "./double-switcher.vue?vue&type=script&lang=js"
export * from "./double-switcher.vue?vue&type=script&lang=js"
import style0 from "./double-switcher.vue?vue&type=style&index=0&id=5ba6d14c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports